module.exports = __webpack_public_path__ + "static/img/wechat.aec9620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat.jpg
// module id = ebUW
// module chunks = 1